export const GET_DATA_PROTECTION_JOBS = `
  query DataProtectionJobs(
    $pageNumber: Int!,
    $pageSize: Int!,
    $storagePolicyIds: [Int!],
    $customerIds: [Int!],
    $commcellIds: [Int!],
    $locationIds: [Int!],
    $statuses: [String!],
    $subclients: [String!],
    $outOfSchedule: Boolean,
    $jobTypes: [String!]
  ) {
    dataProtectionJobs(
      pageNumber: $pageNumber,
      pageSize: $pageSize,
      storagePolicyIds: $storagePolicyIds,
      customerIds: $customerIds,
      commcellIds: $commcellIds,
      locationIds: $locationIds,
      statuses: $statuses,
      subclients: $subclients,
      outOfSchedule: $outOfSchedule,
      jobTypes: $jobTypes
    ) {
      jobType
      subclient
      frequency
      commvaultJobId
      backupLevel
      latestJobStatus
      latestJobStartTime
      latestJobEndTime
      lastCompletedJobTime
      errorMessage
      outOfSchedule
      storagePolicyId
      storagePolicyName
      commcellId
      commcellName
      locationId
      locationName
      customerId
      customerName
    }
  }
`